import { TranslocoService } from '@ngneat/transloco';

export default class AddressUtil {
  static formatFirstAddressBloc(
    addressToFormat: any | null | undefined
  ): string {
    let formattedAddress = '';
    if (addressToFormat) {
      if (addressToFormat.addressLine1) {
        formattedAddress += addressToFormat.addressLine1;
      }

      if (addressToFormat.addressLine2) {
        formattedAddress += ' ' + addressToFormat.addressLine2;
      }
    }
    return formattedAddress;
  }

  static formatSecondAddressBloc(
    addressToFormat: any | null | undefined,
    transloco: TranslocoService
  ): string {
    let formattedAddress = '';
    if (addressToFormat) {
      if (addressToFormat.zipCode) {
        formattedAddress += addressToFormat.zipCode;
      }

      if (addressToFormat.city) {
        formattedAddress += ', ' + addressToFormat.city;
      }

      if (addressToFormat.countryIsoCode) {
        formattedAddress +=
          ', ' +
          transloco.translate(
            'address.countryCode.' +
              addressToFormat.countryIsoCode.toLocaleLowerCase()
          );
      }
    }
    return formattedAddress;
  }
}
